import { useDispatch, useSelector } from "react-redux";
import { submitCheckout } from "../../ducks/checkoutSlice";
import { resetSelfcheckoutSession } from "../../ducks/selfcheckoutSession";
import useGoTo from "../../hooks/useGoTo";
import useSubmitSelfcheckout from "../../hooks/useSubmitSelfcheckout";
import QuestionCheckout from "../QuestionCheckout";

// Tablet de mesa: sem pagamento; o pedido vai para a mesa (ou comanda lida por
// QR Code) e o garçom fecha a conta depois.
export default function SelfCheckoutTable() {
  const dispatch = useDispatch();
  const goTo = useGoTo();
  const { isSelfOrderScanQRCode, inLocoText } = useSelector(
    (state) => state.shop,
  );

  const submit = useSubmitSelfcheckout(async () => {
    const order = await dispatch(submitCheckout({}));
    dispatch(resetSelfcheckoutSession());
    goTo(`/status/${order.shortReference}`);
  });

  return (
    <QuestionCheckout
      comanda={isSelfOrderScanQRCode}
      table={!inLocoText}
      dispatchSubmitCheckout={submit}
    />
  );
}
